import type { BasePatchFrame } from '../janus-engine/compile/base-patch';

/** Use the owning bundle's runtime to repair facets after a committed receipt. */
export function refreshSavedInventory(frame?: BasePatchFrame | null): void {
    if (frame) void window.ftApplyBasePatch?.(frame).catch(error => console.error('[inventory-saved-refresh]', error));
}
